{
  "CSAT": {
    "TITLE": "Avalie sua conversa",
    "PLACEHOLDER": "Conte-nos mais...",
    "RATINGS": {
      "POOR": "😞Ruim",
      "FAIR": "😑 Neutro",
      "AVERAGE": "😐 Mediano",
      "GOOD": "😛 Bom",
      "EXCELLENT": "😍 Excelente"
    }
  }
}
